/**
 * List of entitlements as of March 6th 2019.
 * Note: this may change and won't be updated.
 */
/* istanbul ignore next */
var UserProfileEntitlement;
(function (UserProfileEntitlement) {
    UserProfileEntitlement["GoToMeeting"] = "g2m";
    UserProfileEntitlement["Concierge"] = "concierge";
    UserProfileEntitlement["Grasshopper"] = "grasshopper";
    UserProfileEntitlement["OpenVoice"] = "openvoice";
    UserProfileEntitlement["GoToMyPC"] = "g2p";
    UserProfileEntitlement["GoToTraining"] = "g2t";
    UserProfileEntitlement["GoToAssist"] = "g2a";
    UserProfileEntitlement["GoToAssistSeeit"] = "g2aseeit";
    UserProfileEntitlement["GoToAssistServiceDesk"] = "g2asd";
    UserProfileEntitlement["GoToAssistRemoteSupport"] = "g2ars";
    UserProfileEntitlement["PromptAI"] = "prompt";
    UserProfileEntitlement["Jive"] = "jive";
    UserProfileEntitlement["HVoice"] = "hvoice";
    UserProfileEntitlement["RescueAssist"] = "rescueAssist";
    UserProfileEntitlement["GoToConnect"] = "gotoconnect";
})(UserProfileEntitlement || (UserProfileEntitlement = {}));

export { UserProfileEntitlement };
